import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpClientService } from '../http-client-service';

@Injectable()
export class RolesPermissionsService {
    httpClient: HttpClientService;
    featurePermissions: any;
    constructor(httpClient: HttpClientService) {
        this.httpClient = httpClient;
    }

    public getFeaturePermission(userId: string): any {
        return this.httpClient.get('api/UserQuery/getFeaturePermissions/' + userId).pipe(map(responsedata => {
            var result = responsedata.json();
            this.featurePermissions = result;
            return result;
        }));
    }

    //http error handling #viracor
    // private handleError(error: Response | any) {
    //     let errMsg: string;
    //     if (error instanceof Response) {
    //         const body = error.json() || '';
    //         const err = body.error || JSON.stringify(body);
    //         errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    //     } else {
    //         errMsg = error.message ? error.message : error.toString();
    //     }
    //     return Observable.throw(errMsg);
    // }

}

